import React from 'react';
import { useLocation } from 'react-router-dom';
export default function CertificadoEmitido() {
    const location = useLocation();

    return (
        <div className='mb-4 mx-4' dangerouslySetInnerHTML={{ __html: location.state.certificado.conteudo }}>

        </div>
    );
}   